export const initCompareHomeControlsSubNav = () => {
  const subNav = document.querySelector('[data-compare-home-controls-subnav]');
  const targetSectionAttr = subNav.getAttribute(
    'data-compare-home-controls-subnav'
  );

  const targetSectionEl = document.querySelector(
    `[data-section="${targetSectionAttr}"]`
  );

  if (targetSectionEl) {
    const observer = new IntersectionObserver(callback, { threshold: 0.1 });

    observer.observe(targetSectionEl);
  }

  function callback(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        subNav.setAttribute('data-visible', 'true');
      } else {
        subNav.setAttribute('data-visible', 'false');
      }
    });
  }
};
